import script from "./FileButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FileButton.vue?vue&type=script&setup=true&lang=js"

import "./FileButton.vue?vue&type=style&index=0&id=61f1e773&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f1e773"]])

export default __exports__